export default __webpack_public_path__ + "static/21-b0c9f72819e217144f29243e114a41cb.png";